import { Action, createReducer, on } from '@ngrx/store';

import { Delivery, DeliveryModuleState } from '../../models/delivery.model';
import { ShowInFinalSetupDeliveryRequest } from '../../models/flock-registration-service.model';
import * as deliveryActions from '../actions/delivery.actions';

export const initialState = <DeliveryModuleState>{
  deliveries: [],
  activeDeliveries: [],
  selectedDeliveryId: 0,
  isLoaded: false,
  startDate: null,
  endDate: null,
};

const deliveryReducer = createReducer(
  {
    ...initialState,
    startDate: null,
    endDate: null,
  },
  on(deliveryActions.loadDeliveriesSuccess, (state, { deliveries }) => ({
    ...state,
    deliveries,
    selectedDelivery: null as Delivery,
    isLoaded: true,
  })),
  on(deliveryActions.setDeliveriesFilter, (state, { startDate, endDate }) => ({
    ...state,
    startDate,
    endDate,
  })),
  on(deliveryActions.upsertActiveDeliveriesSuccess, (state, { delivery }) => ({
    ...state,
    deliveries: [
      ...state.deliveries.slice(
        0,
        state.deliveries.indexOf(
          state.deliveries.find(
            (d) => d.id === delivery.deliveryId && d.deliveryOrigin === delivery.origin,
          ),
        ),
      ),
      {
        ...state.deliveries.find(
          (d) => d.id === delivery.deliveryId && d.deliveryOrigin === delivery.origin,
        ),
        deliveryLines: state.deliveries
          .find((d) => d.id === delivery.deliveryId && d.deliveryOrigin === delivery.origin)
          .deliveryLines.map((dl) => {
            const deliveryLine = { ...dl };
            deliveryLine.isActive =
              delivery.activeDeliveryLineExternalUniqueIdentifiers.indexOf(
                deliveryLine.externalUniqueIdentifier,
              ) >= 0;
            return deliveryLine;
          }),
      },
      ...state.deliveries.slice(
        state.deliveries.indexOf(
          state.deliveries.find(
            (d) => d.id === delivery.deliveryId && d.deliveryOrigin === delivery.origin,
          ),
        ) + 1,
      ),
    ],
    selectedDelivery: null as Delivery,
    isLoaded: true,
  })),

  on(deliveryActions.upsertShowInFinalSetupDeliveriesSuccess, (state, { request }) => ({
    ...updateDeliveryLineInState(state, request),
  })),
);

export function reducer(state: DeliveryModuleState | undefined, action: Action) {
  return deliveryReducer(state, action);
}

export function updateDeliveryLineInState(
  state: DeliveryModuleState,
  request: ShowInFinalSetupDeliveryRequest,
): DeliveryModuleState {
  const updatedDeliveries: Delivery[] = JSON.parse(JSON.stringify(state.deliveries));
  const delivery = updatedDeliveries.find((d) => d.id === request.deliveryId);
  const deliveryLine = delivery?.deliveryLines.find(
    (d) => d.externalUniqueIdentifier === request.deliveryLineExternalUniqueIdentifier,
  );

  if (delivery && deliveryLine) {
    deliveryLine.showInFinalSetup = request.showInFinalSetup;

    return {
      ...state,
      deliveries: [...updatedDeliveries],
    };
  }

  return state;
}
